import { FilterSelect } from '@/components/ui/list-filters';
import { INDUSTRIES, REGIONS } from '../constants';
import type { CompanyProfileFilterValues } from '../profileFilters';
import { useCompanyTechnologies } from '../queries';

/** Industry / region / technology rows for a list's Filters popover. */
export function CompanyProfileFilters({
  value,
  onChange,
}: {
  value: CompanyProfileFilterValues;
  onChange: (next: CompanyProfileFilterValues) => void;
}) {
  const technologies = useCompanyTechnologies();
  const technologyOptions = (technologies.data ?? []).map((t) => ({ value: t, label: t }));
  return (
    <div className="grid grid-cols-2 gap-3">
      <FilterSelect
        label="Industry"
        value={value.industry}
        onChange={(industry) => onChange({ ...value, industry })}
        allLabel="Any industry"
        options={INDUSTRIES}
      />
      <FilterSelect
        label="Region"
        value={value.region}
        onChange={(region) => onChange({ ...value, region })}
        allLabel="Any region"
        options={REGIONS}
      />
      <div className="col-span-2">
        <FilterSelect
          label="Technology"
          value={value.technology}
          onChange={(technology) => onChange({ ...value, technology })}
          allLabel="Any technology"
          options={technologyOptions}
        />
      </div>
    </div>
  );
}
